/**
 * BMAT Layout Module
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BMRadioComponent } from './bm-radio.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BMRadioComponent],
  exports: [BMRadioComponent],
})
export class BMRadioComponentModule {}
